import { render } from "./GalleryCard.vue?vue&type=template&id=c22e2384"
import script from "./GalleryCard.vue?vue&type=script&lang=js"
export * from "./GalleryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__